import {
    GTMPageViewBase,
    PageViewAnalyticsEvent,
    PageViewAnalyticsEventData,
} from "@hermes/fragments/analytics";

export interface GTMPageViewGridPage extends GTMPageViewBase {
    pagetype: string | undefined;
    pageTranslate: string;
    /* eslint-disable @typescript-eslint/naming-convention */
    menu_lv1?: string;
    menu_lv2?: string;
    menu_lv3?: string /* eslint-enable @typescript-eslint/naming-convention */;
}

export interface PageViewGridPageData extends PageViewAnalyticsEventData {
    menuLvl: string[] | string | undefined;
}

/**
 * This class is used when the Grid Page is displaying
 */
export class PageViewGridPage extends PageViewAnalyticsEvent {
    public override eventData!: PageViewGridPageData;

    constructor(data: PageViewGridPageData) {
        super(data);
    }
    /**
     * Overload formatForGTM of inherited class
     * Return formatter for eventaction key
     */
    public override formatForGTM(): GTMPageViewGridPage {
        const menuLvl = this.eventData.menuLvl;

        return {
            ...super.formatForGTM(),
            pagetype: this.eventData.pagetype,
            pageTranslate: this.eventData.pageTranslate,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            menu_lv1:
                menuLvl && menuLvl[0]
                    ? menuLvl[0].replace(/"/g, "")
                    : undefined,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            menu_lv2:
                menuLvl && menuLvl[1]
                    ? menuLvl[1].replace(/"/g, "")
                    : undefined,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            menu_lv3:
                menuLvl && menuLvl[2]
                    ? menuLvl[2].replace(/"/g, "")
                    : undefined,
        };
    }
}
